import { moveToStep } from 'features/billing/create_subscription_slice'
import {
  reset,
} from 'features/billing/modals/prompt_to_remove_scheduled_downgrade_modal'
import { steps } from 'features/billing/modals/subscription_modal/steps'

export const promptToRemoveScheduledDowngrade = (dispatch, {
  isDowngradeScheduled,
  unableToChangeTier,
  isSubscriptionExpiring
}) => (
  ({ action = () => null, isDowngrading = false }) => {
    if (isDowngradeScheduled && !unableToChangeTier) {
      dispatch(reset())
      dispatch(moveToStep({
        step: steps.PROMPT_TO_REMOVE_SCHEDULED_DOWNGRADE,
        stepOptions: { isDowngrading }
      }))
      return true
    }

    if (isSubscriptionExpiring) {
      dispatch(moveToStep({
        step: steps.PROMPT_TO_REMOVE_NON_RENEWING_DOWNGRADE
      }))
      return true
    }

    action()

    return false
  }
)
